import { NgModule } from '@angular/core';
import { LogoComponent } from './logo.component';

@NgModule({
    declarations: [LogoComponent],
    imports: [],
    exports: [LogoComponent],
})
export class LogoModule {}
